import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import useTable from "../../components/useTable";
import { IncluirProducOper } from "./incluirProductoVacio";
import {
  validaSoloNumero,
  formatMoneda,
  onCambioMoneda,
} from "../../util/varios";
import moment from "moment";
import CatalogoAlmacen from "../../catalogos/catalogoAlmacen";
import CatalogoOperacionInventario from "../../catalogos/catalogoOperacionInventariovacio";

const TablaOperInventarioVacio = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const btnopvacios = JSON.parse(sessionStorage.getItem("btnopvaciosc"));
  const fechaSistema = moment(
    JSON.parse(sessionStorage.getItem("fechasistema"))
  ).format("YYYY-MM-DD");

  const headCells = [
    { label: "COD.", textAlign: "center", width: "40px" },
    { label: "DESCRIPCION", textAlign: "center", width: "50px" },
    { label: "CANTIDAD", textAlign: "center", width: "30px" },
    { label: "TIPO MOVIMIENTO", textAlign: "center", width: "50px" },
    { label: "FECHA", textAlign: "center", width: "50px" },
    { label: "N° FACTURA", textAlign: "center", width: "50px" },
    {
      label: <i className="fas fa-trash" />,
      textAlign: "center",
      width: "20px",
    },
  ];

  const btnIncluir = useRef();
  const btnEditar = useRef();
  const btnEliminar = useRef();
  const btnConsultar = useRef();
  const btnCancelar = useRef();
  const btnAceptar = useRef();

  const txtIdOpeInv = useRef();
  const txtFecha = useRef();
  const txtCodAlmaOrigen = useRef();
  const txtDescripAlmaOrigen = useRef();
  const txtCodAlmaDestino = useRef();
  const txtDescripAlmaDestino = useRef();
  const txtObservacion = useRef();
  const cmbTipoOperacion = useRef();
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Operaciones de Inventario Vacios."
  );

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitadoM, setHabilitadoM] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [catalogoOpeInv, setCatalogoOpeInv] = useState(false);
  const [catalogoAlmacen, setCatalogoAlmacen] = useState(false);
  const [cualCat, setCualCat] = useState(1);
  const [body, setBody] = useState(null);
  const [visibleAlma, setVisibleAlma] = useState("hidden");
  const [idProd, setIdPro] = useState(0);
  const [desde, setDesde] = useState(0);
  const [regDet, setRegDet] = useState();

  const [mostrar, setMostrar] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacionOper, setOperacionOper] = useState();
  const [records, setRecords] = useState([]);
  const [tipoIngreso, setTipoIngreso] = useState([]);

  const { TblContainer, TblHead } = useTable(records, headCells, {
    fn: (items) => {
      return items;
    },
  });

  const seleccionarRegistro = () => {
    let campos = "*";
    let nomtab = "operacioninventariovacio";
    let nomid = "idoperacioninventario";
    let id = txtIdOpeInv.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtIdOpeInv.current.setAttribute("disabled", true);
            setHabilitarCat(true);
            txtFecha.current.value = moment(response.data.fecha).format(
              "YYYY-MM-DD"
            );
            txtObservacion.current.value = response.data.observacion.trim();
            if (response.data.tipooperacion === "INGRESO") {
              cmbTipoOperacion.current.value = "1";
            } else if (response.data.tipooperacion === "SALIDA") {
              cmbTipoOperacion.current.value = "2";
            } else if (response.data.tipooperacion === "TRASLADO") {
              cmbTipoOperacion.current.value = "3";
            }

            llenarTipoIngreso(parseInt(cmbTipoOperacion.current.value));

            seleccionarAlmacen(response.data.idalmacenorigen, 1);
            txtCodAlmaOrigen.current.value = response.data.idalmacenorigen;
            if (response.data.idalmacendestino === null) {
              setVisibleAlma("hidden");
            } else {
              setVisibleAlma("visible");
              txtCodAlmaDestino.current.value = response.data.idalmacendestino;
              seleccionarAlmacen(response.data.idalmacendestino, 2);
            }
            seleccionarDetalle();
            if (operacion === 2) {
              setHabilitado(true);
              setTimeout(() => txtFecha.current.focus(), 200);
            } else {
              setTimeout(() => btnCancelar.current.focus(), 200);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdOpeInv.current.value = "";
            txtIdOpeInv.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = () => {
    let nomtab = "operacioninventariovaciodetalle";
    let nomid = "idoperacioninventario";
    let id = txtIdOpeInv.current.value;
    let endpoint = `${op.conexion}/api/inventariovacio/selectdetalleopeinv?nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let prod = [];
            for (let i = 0; i < response.data.length; i++) {
              if (
                response.data[i].idalmacen === txtCodAlmaOrigen.current.value
              ) {
                prod.push({
                  idclasevacio: response.data[i].idclasevacio,
                  descripcion: response.data[i].descripcion,
                  cantidad:
                    response.data[i].cantidad < 0
                      ? response.data[i].cantidad * -1
                      : response.data[i].cantidad,
                  tipomovimiento: response.data[i].tipomovimiento,
                  fechatipomovimiento:
                    response.data[i].fechatipomovimiento === null
                      ? ""
                      : response.data[i].fechatipomovimiento,
                  numfactura: response.data[i].numfactura,
                });
              }
            }
            setRecords(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarAlmacen = (cod, llamado) => {
    let campos = "*";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let id = cod;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (llamado === 1) {
              txtDescripAlmaOrigen.current.value =
                response.data.descripcion.trim();
              if (cmbTipoOperacion.current.value === "3") {
                txtCodAlmaDestino.current.focus();
              } else {
                btnAceptar.current.focus();
              }
            } else {
              txtDescripAlmaDestino.current.value =
                response.data.descripcion.trim();
            }
          } else {
            if (llamado === 1) {
              txtCodAlmaOrigen.current.value = "";
              txtCodAlmaOrigen.current.focus();
            } else {
              txtCodAlmaDestino.current.value = "";
              txtCodAlmaDestino.current.focus();
            }
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Almacen no esxite",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        if (llamado === 1) {
          txtCodAlmaOrigen.current.value = "";
          txtCodAlmaOrigen.current.focus();
        } else {
          txtCodAlmaDestino.current.value = "";
          txtCodAlmaDestino.current.focus();
        }
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/inventariovacio/actualizaropeinv/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " + response.data.idopeinv + " creado correctamente",
              icono: "exito",
            });
/*             window.open(
              op.reportes +
                `/almacen?afiliado=${organizacion}&reporte=ReporteDetaOpeInventario&codigo=${response.data.idopeinv}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            ); */
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.idopeinv +
                " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.idopeinv +
                " eliminado correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const gestionOper = (op, id, index) => (e) => {
    e.preventDefault();
    setOperacionOper(op);
    if (op === 1) {
      if (txtCodAlmaOrigen.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el almacen",
          icono: "informacion",
        });
        txtCodAlmaOrigen.current.focus();
        return;
      }
      setMostrar(true);
    } else if (op === 2) {
      setRegDet(records[index]);
      setMostrar(true);
    } else if (op === 3) {
      setIdPro(id);
      setDesde(1);
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta seguro de eliminar el registro?",
        icono: "confirmacion",
      });
    }
  };

  const closeGestionOper = (op) => {
    setMostrar(false);
  };

  const closeAceptarGestionOper = (datos) => {
    let prod = [];

    for (let i = 0; i < records.length; i++) {
      prod.push({
        idclasevacio: records[i].idclasevacio,
        descripcion: records[i].descripcion,
        cantidad: records[i].cantidad,
        tipomovimiento: records[i].tipomovimiento,
        fechatipomovimiento: records[i].fechatipomovimiento,
        numfactura: records[i].numfactura,
      });
    }
    prod.push({
      idclasevacio: datos[0].idclasevacio,
      descripcion: datos[0].descripcion,
      cantidad: datos[0].cantidad,
      tipomovimiento: datos[0].tipomovimiento,
      fechatipomovimiento: datos[0].fechatipomovimiento,
      numfactura: datos[0].numfactura,
    });
    setMostrar(false);
    setRecords(prod);
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      let prod = [];
       prod = records.filter(function (prod) {
        return prod.idclasevacio !== idProd;
      });
      setDesde(0);
      setRecords(prod);
    } else if (desde === 2) {
      setDesde(0);
      procesarRegistro();
    }
    /*  getExpendedor(); */
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.target.name === "codalmaorigen") {
      txtDescripAlmaOrigen.current.value = "";
      setRecords([]);
    } else if (event.target.name === "codalmadestino") {
      txtDescripAlmaDestino.current.value = "";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idopeinv") {
          seleccionarRegistro();
        } else if (event.target.name === "codalmaorigen") {
          seleccionarAlmacen(event.target.value, 1);
        } else if (event.target.name === "codalmadestino") {
          seleccionarAlmacen(event.target.value, 2);
        }
      }
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fechaope") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        cmbTipoOperacion.current.focus();
      } else if (event.target.name === "codalmaorigen") {
      } else if (event.target.name === "codalmadestino") {
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fechaope") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (btnopvacios && btnopvacios.toString().substring(0, 1) === "1") {
        setTituloHeader("Incluir Operacion de Inventario Vacio.");
        setVisibleBtn("hidden");
        setHabilitadoBot(false);
        setOperacion(op);
        setHabilitadoM(true);
        setHabilitado(true);
        txtIdOpeInv.current.value = "0";
        txtIdOpeInv.current.setAttribute("disabled", true);
        setHabilitarCat(true);
        txtFecha.current.value = fechaSistema;
        cmbTipoOperacion.current.selectedIndex = 0;
        llenarTipoIngreso(1);
        setTimeout(() => txtFecha.current.focus(), 200);
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (btnopvacios && btnopvacios.toString().substring(1, 2) === "1") {
        setVisibleBtn("hidden");
        setTituloHeader("Editar Operacion de Inventario Vacio.");
        setOperacion(op);
        setHabilitadoBot(false);
        txtIdOpeInv.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitadoM(false);
        setHabilitado(false);
        txtIdOpeInv.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (btnopvacios && btnopvacios.toString().substring(3, 4) === "1") {
        setTituloHeader("Eliminar Operacion de Inventario Vacio.");
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitadoBot(false);
        txtIdOpeInv.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitadoM(false);
        setHabilitado(false);
        txtIdOpeInv.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (btnopvacios && btnopvacios.toString().substring(2, 3) === "1") {
        setTituloHeader("Consultar Operacion de Inventario Vacio.");
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitadoM(false);
        setHabilitado(false);
        setHabilitadoBot(false);
        txtIdOpeInv.current.removeAttribute("disabled");
        setHabilitarCat(false);
        txtIdOpeInv.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      if (operacion !== 4) {
        onChangeValidar();
      }
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
    }
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Operaciones de Inventario Vacio.");
    setActivate(false);
    setBody(null);
    setHabilitado(false);
    setHabilitadoM(false);
    setHabilitadoBot(true);
    setHabilitarCat(true);
    txtIdOpeInv.current.setAttribute("disabled", true);
    txtIdOpeInv.current.value = "";
    txtFecha.current.value = "";
    txtObservacion.current.value = "";
    txtCodAlmaOrigen.current.value = "";
    txtDescripAlmaOrigen.current.value = "";
    if (cmbTipoOperacion.current.value === "3") {
      txtCodAlmaDestino.current.value = "";
      txtDescripAlmaDestino.current.value = "";
    }
    cmbTipoOperacion.current.selectedIndex = -1;
    setVisibleAlma("hidden");
    setRecords([]);
    setVisibleBtn("visible");
  };

  const llenarTipoIngreso = (tipoing) => {
    let tipo = [];
    if (tipoing === 1) {
      setVisibleAlma("hidden");

      tipo.push({
        idtipo: "1",
        descripcion: "INVENTARIO INICIAL",
      });
      tipo.push({
        idtipo: "2",
        descripcion: "RECEPCION",
      });
      tipo.push({
        idtipo: "3",
        descripcion: "AJUSTE",
      });
    } else if (tipoing === 2) {
      tipo.push({
        idtipo: "1",
        descripcion: "DESPACHO",
      });
      tipo.push({
        idtipo: "2",
        descripcion: "AJUSTE",
      });
      setVisibleAlma("hidden");
    } else if (tipoing === 3) {
      tipo.push({
        idtipo: "1",
        descripcion: "TRASLADO",
      });
      setVisibleAlma("visible");
    }
    setTipoIngreso(tipo);
  };

  const onChange = (e) => {
    if (e.target.name === "tipoopeinv") {
      if (e.target.value === "3") {
        setVisibleAlma("visible");
      } else {
        setVisibleAlma("hidden");
      }
      llenarTipoIngreso(parseInt(e.target.value));
    } else if (e.target.name === "fechaope") {
    }
  };

  const onCatalogoOperacionInv = (values) => {
    setCatalogoOpeInv(false);
    txtIdOpeInv.current.value = values.idoperacioninventario;
    seleccionarRegistro();
  };

  const onCatalogoAlmacen = (values) => {
    setCatalogoAlmacen(false);
    if (cualCat === 1) {
      txtCodAlmaOrigen.current.value = values.idalmacen;
      //txtDescripUbiOrigen.current.value = values.descripcion.trim() + ' Almacen: ' + response.data[0].descripcion.trim();
    } else {
      txtCodAlmaDestino.current.value = values.idalmacen;
      //txtDescripUbiDestino.current.value = values.descripcion;
    }
    seleccionarAlmacen(values.idalmacen, cualCat);
  };

  const onChangeValidar = () => {
    var sigue = true;

    if (txtIdOpeInv.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtIdOpeInv.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Observación no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (txtCodAlmaOrigen.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código del Almacen no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodAlmaOrigen.current.focus();
    } else if (
      cmbTipoOperacion.current.value === "3" &&
      txtCodAlmaDestino.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código del Almacen Destino no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodAlmaDestino.current.focus();
    } else if (
      cmbTipoOperacion.current.value === "3" &&
      txtCodAlmaOrigen.current.value.trim() ===
        txtCodAlmaDestino.current.value.trim()
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código del Almacen Oriregen y Destino no deben ser iguales",
        icono: "informacion",
      });
      sigue = false;
      txtCodAlmaDestino.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Producto agregados",
        icono: "informacion",
      });
      sigue = false;
      btnCancelar.current.focus();
    }

    if (sigue) {
      var opeinv = [];
      var opeinvdet = [];

      opeinv.push({
        idoperacioninventario: txtIdOpeInv.current.value,
        tipooperacion:
          cmbTipoOperacion.current[cmbTipoOperacion.current.selectedIndex].text,
        idalmacenorigen: txtCodAlmaOrigen.current.value,
        idalmacendestino:
          cmbTipoOperacion.current.value === "3"
            ? txtCodAlmaDestino.current.value
            : "",
        fecha: txtFecha.current.value,
        observacion: txtObservacion.current.value,
      });

      for (let i = 0; i < records.length; i++) {
        opeinvdet.push({
          idclasevacio: records[i].idclasevacio,
          descripcion: records[i].descripcion,
          cantidad: records[i].cantidad,
          tipomovimiento: records[i].tipomovimiento,
          fechatipomovimiento: records[i].fechatipomovimiento,
          numfactura: records[i].numfactura,
          idalmacen: txtCodAlmaOrigen.current.value,
        });
      }

      setBody({
        idtipopeinv: cmbTipoOperacion.current.value,
        opeinv: opeinv,
        opeinvdet: opeinvdet,
      });
      setDesde(2);
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const imprimirReporte = () => {
    if (txtIdOpeInv.current.value !== "") {
      window.open(
        `${op.reportes}/almacen?afiliado=${organizacion}&reporte=ReporteDetaOpeInventario&codigo=${txtIdOpeInv.current.value}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  useEffect(() => {
    if (cmbTipoOperacion) {
      cmbTipoOperacion.current.selectedIndex = -1;
    }
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 py-5 px-5" style={{ margin: 0 }}>
        <div className="row col-md-12 px-5" style={{ margin: 0 }}>
          <IncluirProducOper
            show={mostrar}
            onHideCancela={closeGestionOper}
            onHideAcepta={closeAceptarGestionOper}
            operacion={operacionOper}
            idalmacen={
              txtCodAlmaOrigen.current ? txtCodAlmaOrigen.current.value : ""
            }
            tipoingreso={tipoIngreso}
            tipo={
              cmbTipoOperacion.current
                ? parseInt(cmbTipoOperacion.current.value)
                : ""
            }
            productos={records}
            registro={regDet}
          />

          <Mensaje
            mensaje={mensaje}
            onHide={() => {
              mensaje.titulo === "Exito."
                ? cerrarModal()
                : setMensaje({
                    mostrar: false,
                    titulo: "",
                    texto: "",
                    icono: "",
                  });
            }}
          />
          <MensajeSiNo
            mensaje={mensajesino}
            onHideNo={() =>
              setMensajesino({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              })
            }
            onHideSi={handleCloseSi}
          />
          <Dimmer active={activate} inverted>
            <Loader inverted>cargando...</Loader>
          </Dimmer>
          <CatalogoAlmacen
            show={catalogoAlmacen}
            onHideCancelar={() => setCatalogoAlmacen(false)}
            onHideAceptaCatalogo={onCatalogoAlmacen}
          />
          <CatalogoOperacionInventario
            show={catalogoOpeInv}
            onHideCancelar={() => setCatalogoOpeInv(false)}
            onHideAceptaCatalogo={onCatalogoOperacionInv}
          />
          <div className="py-3">
            <div className="p-3 col-md-11 mx-auto card shadow row m-0">
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between">
                <div className="col-md-4">
                  <h3>{tituloHeader}</h3>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>
              <div
                className="col-md-12 row mx-auto row m-0"
                style={{ fontSizeAdjust: "0,6" }}
              >
                <div className="input-group mb-3 col-pd-280">
                  <span
                    className="input-group-text fw-bold"
                    id="inputGroup-sizing-default"
                  >
                    CODIGO:
                  </span>
                  <input
                    type="text"
                    className="form-control fs-5 h-100"
                    autoComplete="off"
                    disabled
                    ref={txtIdOpeInv}
                    name="idopeinv"
                    onKeyUp={handleInputNumeroChange}
                    onBlur={handleInputNumeroChange}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                  />
                  <button
                    disabled={habilitarCat}
                    type="button"
                    onClick={() => setCatalogoOpeInv(true)}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>

              <div className="border-azul py-3 rounded row rounded mx-auto tipo-letra">
                <div
                  className="input-group mb-2 col-pd-360"
                  style={{ fontSizeAdjust: "0,6" }}
                >
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    FECHA DE INGRESO:
                  </label>
                  <input
                    type="date"
                    disabled={!habilitado}
                    ref={txtFecha}
                    max={moment(fechaSistema).format("YYYY-MM-DD")}
                    name="fechaope"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    className="form-control fs-5 text-uppercase h-100"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                  />
                </div>

                <div
                  className="input-group mb-2 col-pd-340"
                  style={{ fontSizeAdjust: "0,6", marginLeft: "auto" }}
                >
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    TIPO DE OPERACION:
                  </label>
                  <select
                    disabled={!habilitadoM}
                    ref={cmbTipoOperacion}
                    className="form-select"
                    aria-label="Default select example"
                    name="tipoopeinv"
                    onChange={onChange}
                  >
                    <option value="1">INGRESO</option>
                    <option value="2">SALIDA</option>
                    <option value="3">TRASLADO</option>
                  </select>
                </div>

                <div
                  className="input-group mb-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 mx-auto"
                  style={{ fontSizeAdjust: "0,6" }}
                >
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    OBSERVACION:
                  </label>
                  <textarea
                    type="area"
                    disabled={!habilitado}
                    maxLength="500"
                    style={{
                      height: 80,
                    }}
                    autoComplete="off"
                    ref={txtObservacion}
                    className="form-control text-uppercase fs-5"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                  />
                </div>
                <div className="col-md-12" style={{ fontSizeAdjust: "0,6" }}>
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between">
                    <legend className="float-none w-auto fw-bold">
                      ALMACÉN {visibleAlma !== "hidden" && "ORIGEN"}
                    </legend>
                    <div className="input-group mb-2 col-md-12">
                      <div className="input-group mb-1 col-xl-3 col-lg-4 col-md-5 col-sm-6">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-default"
                        >
                          CODIGO:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoM}
                          ref={txtCodAlmaOrigen}
                          autoComplete="off"
                          className="form-control fs-5 text-uppercase h-100"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-default"
                          name="codalmaorigen"
                          onKeyUp={handleInputNumeroChange}
                          onBlur={handleInputNumeroChange}
                        />
                        <button
                          type="button"
                          disabled={!habilitado}
                          onClick={() => {
                            setCualCat(1);
                            setCatalogoAlmacen(true);
                          }}
                          className="btn btn-success"
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>

                      <div className="input-group mb-1 col-xl-9 col-lg-12 col-md-12 col-sm-12">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-default"
                        >
                          DESCRIPCION:
                        </label>
                        <input
                          type="text"
                          disabled
                          ref={txtDescripAlmaOrigen}
                          className="form-control fs-5 text-uppercase h-100"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-default"
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>

                {visibleAlma !== "hidden" && (
                  <div className="col-md-12" style={{ fontSizeAdjust: "0,6" }}>
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between">
                      <legend className="float-none w-auto fw-bold">
                        ALMACÉN DESTINO
                      </legend>

                      <div className="input-group mb-2 col-md-12">
                        <div className="input-group mb-1 col-xl-3 col-lg-4 col-md-5 col-sm-6">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-default"
                          >
                            CODIGO:
                          </label>
                          <input
                            type="text"
                            disabled={!habilitadoM}
                            ref={txtCodAlmaDestino}
                            className="form-control fs-6"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-default"
                            name="codalmadestino"
                            onKeyUp={handleInputNumeroChange}
                            onBlur={handleInputNumeroChange}
                          />
                          <button
                            type="button"
                            disabled={!habilitado}
                            onClick={() => {
                              setCualCat(2);
                              setCatalogoAlmacen(true);
                            }}
                            className="btn btn-success"
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>

                        <div className="input-group mb-1 col-xl-9 col-lg-12 col-md-12 col-sm-12">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-default"
                          >
                            DESCRIPCION:
                          </label>
                          <input
                            type="text"
                            disabled
                            ref={txtDescripAlmaDestino}
                            className="form-control fs-6 text-uppercase"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-default"
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                )}
                <div className="col-md-12 mx-auto row">
                  <div className="col-12 p-2">
                    <div className="row col-12 d-flex justify-content-end">
                      <div className="col-3 d-flex justify-content-end">
                        <button
                          disabled={!habilitado}
                          onClick={gestionOper(1, 0, 0)}
                          className="btn btn-sm mx-1 btn-primary rounded-pill"
                          title="Incluir Vacio"
                        >
                          <i className="fas fa-plus"> Incluir Vacio</i>{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12" style={{ margin: "auto" }}>
                    <TblContainer>
                      <TblHead />
                      <TableBody>
                        {records &&
                          records.map((item, index) => (
                            <TableRow
                              key={index}
                              style={{ padding: "0", fontSizeAdjust: "0.6" }}
                            >
                              <TableCell
                                className="align-middle bg-light text-center p-0"
                                style={{ width: "40px" }}
                              >
                                {item.idclasevacio}{" "}
                              </TableCell>
                              <TableCell
                                className="align-middle bg-light text-start p-0 pl-2"
                                style={{ width: "50px" }}
                              >
                                {item.descripcion}{" "}
                              </TableCell>
                              <TableCell
                                className="align-middle bg-light text-end p-0 pr-2"
                                style={{ width: "30px" }}
                              >
                                {formatMoneda(
                                  item.cantidad
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}{" "}
                              </TableCell>
                              <TableCell
                                className="align-middle bg-light text-center p-0"
                                style={{ width: "50px" }}
                              >
                                {item.tipomovimiento}{" "}
                              </TableCell>
                              <TableCell
                                className="align-middle bg-light text-center p-0"
                                style={{ width: "50px" }}
                              >
                                {item.fechatipomovimiento === ""
                                  ? ""
                                  : moment(item.fechatipomovimiento).format(
                                      "DD/MM/YYYY"
                                    )}{" "}
                              </TableCell>
                              <TableCell
                                className="align-middle bg-light text-center p-0"
                                style={{ width: "50px" }}
                              >
                                {item.numfactura}{" "}
                              </TableCell>
                              <TableCell
                                className="align-middle bg-light text-center p-0"
                                style={{ width: "20px" }}
                              >
                                <button
                                  disabled={!habilitado}
                                  style={{
                                    visibility:
                                      (operacion === 4 || operacion === 3) &&
                                      "collapse",
                                  }}
                                  onClick={gestionOper(
                                    3,
                                    item.idclasevacio,
                                    index
                                  )}
                                  className="btn btn-sm btn-danger"
                                >
                                  <i className="fa fa-trash"></i>{" "}
                                </button>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </TblContainer>
                    {/*<TblPagination />*/}
                  </div>
                </div>

                <div className="col-md-12 d-flex justify-content-between mt-2">
                  {visibleBtn === "visible" ? (
                    <div className="col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start">
                      <button
                        ref={btnIncluir}
                        onClick={onBotones(1)}
                        disabled={!habilitadoBot}
                        className="btn btn-sm mx-1 btn-primary rounded-pill"
                        title="Incluir Operacion de Inventario"
                      >
                        <i className="fas fa-plus"> Incluir </i>{" "}
                      </button>
                      <button
                        ref={btnConsultar}
                        onClick={onBotones(4)}
                        disabled={!habilitadoBot}
                        className="btn btn-sm mx-1 btn-info rounded-pill"
                        title="Consultar Operacion de Inventario"
                      >
                        <i className="fas fa-eye">Consultar</i>{" "}
                      </button>
                      <button
                        ref={btnEditar}
                        onClick={onBotones(2)}
                        disabled={!habilitadoBot}
                        className="btn btn-sm mx-1 btn-warning rounded-pill"
                        title="Modificar Operacion de Inventario"
                      >
                        <i className="fa fa-edit">Modificar</i>{" "}
                      </button>
                      <button
                        ref={btnEliminar}
                        onClick={onBotones(3)}
                        className="btn btn-sm mx-1 btn-danger rounded-pill"
                        title="Eliminar Operacion de Inventario"
                      >
                        <i className="fa fa-trash">Eliminar</i>{" "}
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {visibleBtn === "visible" ? (
                    ""
                  ) : (
                    <div className="col-md-12 d-flex justify-content-end">
                      {/*                       <button
                        onClick={imprimirReporte}
                        disabled={operacion === 4 ? false : true}
                        className="btn btn-sm btn-primary rounded-pill"
                        title="Imprimir operacion de inventario"
                      >
                        <i className="fa fa-print"> Imprimir</i>
                      </button> */}

                      <button
                        disabled={habilitadoBot}
                        onClick={onBotones(5)}
                        ref={btnAceptar}
                        className="mx-2 btn btn-sm rounded-pill btn-success"
                        title="Aceptar"
                      >
                        <i className="fas fa-check-circle"> Aceptar</i>
                      </button>
                      <button
                        disabled={habilitadoBot}
                        onClick={onBotones(6)}
                        ref={btnCancelar}
                        className="mx-2 btn btn-danger btn-sm rounded-pill"
                        title="Cancelar"
                      >
                        <i className="fas fa-window-close"> Cancelar</i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*       <GestionarOperaciones 
      show={mostrar}
      onHideCancela={cerramodal}
      operacion={operacion}
      />
 */}
    </div>
  );
};
export default TablaOperInventarioVacio;



// WEBPACK FOOTER //
// ./src/components/almacen/tablaOperInventariovacio.js